import React, { useMemo, ReactNode } from 'react';

interface PageContentProps {
  children?: ReactNode;
  flexDirection?: string;
  maxWidth?: string;
  marginTop?: number;
}

function PageContent({ children, flexDirection, maxWidth, marginTop }: PageContentProps): JSX.Element {
  const style = useMemo(
    () => ({
      display: 'flex',
      flexDirection: flexDirection || 'column',
      maxWidth: maxWidth || undefined,
      marginTop: marginTop || undefined,
    }),
    [flexDirection, maxWidth, marginTop],
  );

  return <div style={style}>{children}</div>;
}

export default PageContent;
